"use client";
import React from "react";

export const Comment = ({ comment }) => {
  const hasAttachment = comment.attachment && comment.attachment.url;

  return (
    <div className="py-3 border-b border-gray-100 last:border-0">
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 text-sm font-medium">
          {comment.author.charAt(0).toUpperCase()}
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-medium text-gray-800">{comment.author}</span>
            <span className="text-xs text-gray-500">
              {new Date(comment.date).toLocaleDateString()}
            </span>
          </div>
          <p className="text-sm text-gray-700 mb-2">{comment.content}</p>

          {hasAttachment && (
            <div className="mt-2 mb-3">
              {comment.attachment.type === "image" ? (
                <div className="relative group">
                  <img
                    src={comment.attachment.url}
                    alt="Attachment"
                    className="max-h-40 rounded-lg border border-gray-200 object-cover"
                  />
                  <a
                    href={comment.attachment.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-200 rounded-lg"
                  >
                    <span className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                      View full size
                    </span>
                  </a>
                </div>
              ) : comment.attachment.type === "video" ? (
                <video
                  controls
                  className="max-h-40 rounded-lg border border-gray-200"
                >
                  <source src={comment.attachment.url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <a
                  href={comment.attachment.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-blue-500 hover:text-blue-700"
                >
                  <svg
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 4a3 3 0 00-3 3v4a3 3 0 006 0V7a1 1 0 112 0v4a5 5 0 01-10 0V7a5 5 0 0110 0v1.5a1.5 1.5 0 01-3 0V6a1 1 0 012 0v2.5a3.5 3.5 0 01-7 0V6a5 5 0 0110 0v4a3 3 0 01-6 0V7a1 1 0 00-2 0v4a3 3 0 003 3h4a3 3 0 003-3V7a5 5 0 00-5-5H7a5 5 0 00-5 5v4a5 5 0 005 5h4a1 1 0 110 2H7a7 7 0 01-7-7V7a7 7 0 017-7h4a7 7 0 017 7v4a5 5 0 01-5 5h-4a5 5 0 01-5-5V7a3 3 0 013-3h4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  {comment.attachment.name || "Attachment"}
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
